import { tokenKey } from "./constants";
export const redirectFunc = (error) => {
  console.log(error);

  // A network failure/timeout has no `response` at all. Without the guard this
  // throws inside the caller's catch block, so the real error never surfaces.
  if (error?.response?.status === 403 || error?.response?.status === 401) {
    localStorage.removeItem(tokenKey);
    window.location.replace(`${window.location.origin}/login`);
  }
};
